import { FunctionComponent } from 'preact';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'preact/hooks';
import { useStyles } from '../../../../common/hooks/useStyles';
import { getKeepWatchingButtonsStyleObject } from './keepWatchingButtons.style';
import { getPlayNextButtonId, getStayButtonId } from '../../htmlElements/htmlElementsIdGetter';
import {
  DISCOVERY_SHOW_NEXT_VIDEO_IN_TOTAL_SECONDS,
  DISCOVERY_SHOW_SKIPPABLE_CONTENT_DEFAULT_SECONDS,
  DISCOVERY_SHOW_SKIPPABLE_CONTENT_KEEP_WATCHING_DEFAULT_SECONDS,
  DISCOVERY_SKIPPABLE_CONTENT_PLAY_NEXT_BUTTON,
  DISCOVERY_SKIPPABLE_CONTENT_STAY_BUTTON,
} from '../../discoveryPlugin.constants';
import { playerDataSelector } from '../../../../common/store/selectors/playerData.selector';
import { discoverySelector } from '../../../../common/store/selectors/discovery.selector';
import {
  playNextVideo,
  replayVideo,
  updateShowSkippableContent,
} from '../../store/discoveryPlugin.actions';
import { mediaDataSelector } from '../../../../common/store/selectors/mediaData.selector';

export const KeepWatchingButtons: FunctionComponent = () => {
  const dispatch = useDispatch();
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqId);
  const showSkippableContent = useSelector(discoverySelector.showSkippableContent);
  const currentVideoTimeFragment = useSelector(playerDataSelector.currentVideoTimeFragment);
  const videoList = useSelector(mediaDataSelector.videoList);
  const skippableContentTime = useSelector(discoverySelector.skippableContentTime);

  const keepWatchingButtonsTime = skippableContentTime === DISCOVERY_SHOW_SKIPPABLE_CONTENT_DEFAULT_SECONDS ? DISCOVERY_SHOW_SKIPPABLE_CONTENT_KEEP_WATCHING_DEFAULT_SECONDS : skippableContentTime;
  const countdownTime = showSkippableContent ? currentVideoTimeFragment - keepWatchingButtonsTime : 0;
  const isSingleVideo = videoList.length === 1;

  const styles = useStyles(getKeepWatchingButtonsStyleObject, [countdownTime]);
  const { keepWatchingButtonsContainerStyle, stayButtonStyle, playNextButtonStyle, stayTextStyle, playNextTextStyle, playNextFillButtonStyle } = styles;

  useEffect(() => {
    if (countdownTime >= DISCOVERY_SHOW_NEXT_VIDEO_IN_TOTAL_SECONDS) {
      if (isSingleVideo) {
        dispatch(replayVideo());
      } else {
        dispatch(playNextVideo());
      }
    }
  }, [countdownTime, isSingleVideo, dispatch]);

  const onClickPlayNext = (): void => {
    dispatch(playNextVideo());
  };

  const onClickStay = (): void => {
    dispatch(updateShowSkippableContent(false));
  };

  const onKeyDownPlayNext = (event: any): void => {
    if (event.key === 'Enter') {
      onClickPlayNext();
    }
  };

  const onKeyDownStay = (event: any): void => {
    if (event.key === 'Enter') {
      onClickStay();
    }
  };

  return (
    <div style={keepWatchingButtonsContainerStyle}>
      <div id={getStayButtonId(playerUniqueId)} style={stayButtonStyle} onClick={onClickStay} tabIndex={0} onKeyDown={onKeyDownStay}>
        <span style={stayTextStyle}>
          {DISCOVERY_SKIPPABLE_CONTENT_STAY_BUTTON}
        </span>
      </div>
      <div id={getPlayNextButtonId(playerUniqueId)} style={playNextButtonStyle} onClick={onClickPlayNext} tabIndex={0} onKeyDown={onKeyDownPlayNext}>
        <div style={playNextFillButtonStyle} />
        <span style={playNextTextStyle}>
          {DISCOVERY_SKIPPABLE_CONTENT_PLAY_NEXT_BUTTON}
        </span>
      </div>
      <div />
    </div>
  );
};
